module.exports = __webpack_public_path__ + "img/greenReadingArt4.bcb1f5d0.png";